import * as types from './diocese.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	get: payload => ({
		type: types.GET_DIOCESE,
		payload,
	}),
	set: payload => ({
		type: types.SET_DIOCESE,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_DIOCESE,
		payload,
	}),
	remove: payload => ({
		type: types.DELETE_DIOCESE,
		payload,
	}),
	getStaticOptions: payload => ({
		type: types.GET_STATIC_OPTIONS,
		payload,
	}),
	getDynamicOptions: payload => ({
		type: types.GET_DYNAMIC_OPTIONS,
		payload,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
